import { getCounterEndTimeCookie } from 'publisher/utils/cookie'

export const getNotExpiredStoredStartTime = (
  pageId: number,
  postFix: number | null,
) => {
  const endTime = getCounterEndTimeCookie(pageId, postFix) as number
  return endTime > Date.now() ? +endTime : null
}
